export default "__VITE_ASSET__0O5hwPHC__"